import React, { useCallback, useRef } from 'react'
import { HeadingVariant } from '@/components/composed/ConsultingForm/constants'
import type { IConsultingFormProps } from '@/components/composed/ConsultingForm/types'
import type {
  TFinancingRequestStepperFormComponentProps,
  TFinancingRequestStepperLoginComponentProps,
  TFinancingRequestStepperRegistrationComponentProps,
} from '@/components/composed/financing/FinancingRequestStepper/types'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { ConsultingFormModal } from '@/components/composed/modals'
import { ApplyingFinancingOfferSuccessModal } from '@/pages/Financing/components'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { FinancingConsultingWrapper } from '../FinancingConsultingWrapper'
import { ConsultingForm } from './components'
import './styles.scss'

addModalToWellKnown({ ApplyingFinancingOfferSuccessModal })
addModalToWellKnown({ ConsultingFormModal })

type TProps<TForm extends Record<string, unknown>> =
  | TFinancingRequestStepperFormComponentProps<TForm>
  | TFinancingRequestStepperLoginComponentProps<TForm>
  | TFinancingRequestStepperRegistrationComponentProps<TForm>

export const FinancingConsultingFormStep = ({ onStartRegistration, onStartLogin, onAfterFormSubmit, onError }: TProps<{}>) => {
  const firstInputRef = useRef<HTMLInputElement & HTMLTextAreaElement>(null)
  const { isMobile } = useDeviceType()

  const handleHeaderClick = useCallback(() => {
    if (!firstInputRef.current || !isMobile) {
      return
    }

    firstInputRef.current.focus()
    firstInputRef.current.scrollIntoView({ block: 'nearest' })
  }, [firstInputRef, isMobile])

  return (
    <FinancingConsultingWrapper onHeaderClick={handleHeaderClick}>
      <ConsultingForm
        firstInputRef={firstInputRef as IConsultingFormProps['firstInputRef']}
        headingVariant={!isMobile ? HeadingVariant.FORM_ON_MAIN_FINANCING_PAGE : HeadingVariant.FORM_ON_MAIN_FINANCING_PAGE_MOBILE}
        registrationFormClassName="financingConsultingFormStep__registrationForm"
        onOpenRegistrationForm={onStartRegistration}
        onChangeLoginDialogOpen={onStartLogin}
        onSuccessFormSubmit={onAfterFormSubmit}
        onErrorFormSubmit={onError}
        shouldSkipSuccessModal
      />
    </FinancingConsultingWrapper>
  )
}
